import React, {memo, useEffect, useRef, useState} from 'react';
import {Box, Paper} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {contentAction, packageTypeAction, productAction} from "../../actions";
import {connect, useSelector} from "react-redux";
import Button from "@mui/material/Button";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {TagAutocomplete} from "../index";
import Chip from "@mui/material/Chip";
import {Loading} from './../../components'
import SelectProduct from "../selectProducts/selectProduct";
import SunEditor, {buttonList} from "suneditor-react";

const ProductEditSeo = memo((props) => {

    const {productID, onComplete} = props;
    const [form, setForm] = useState({});
    const [editorData, setEditorData] = useState({});
    const [loading, setLoading] = useState(true);
    const [tag, setTag] = useState([]);
    // const [relatedItem, setRelatedItem] = useState([]);
    const productReducer = useSelector((state) => state.productReducer)
    const contentReducer = useSelector((state) => state.contentReducer)
    const editor = useRef();
    useEffect(() => {

        new Api().get('/products/' + productID + '/seo').then((response) => {
            if (typeof response !== "undefined") {

                let init_tags = [];
                if (response.tags) {
                    response.tags.map((t) => {
                        init_tags.push(t.id);
                    });
                }

                setTag(init_tags);

                setForm(response);
                // setRelatedItem(response.related_product)

            }
            setLoading(false);
        })
    }, []);



    const handleChangeElement = (event) => {
        let frm = form;
        frm[event.target.name] = event.target.value;
        setForm({...frm});
    };

    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        let arr = []
        let blogArr = []
        await form["related_product"]?.forEach((item) => {
            arr.push(item?.id)
        })
        form["related_product"] = arr

       await form["related_blogs"]?.forEach((item) => {
           blogArr.push(item?.id)
        })
        form["related_blogs"] = blogArr


        setLoading(true);

        let n_form = {...form , ...editorData};
        n_form['tags'] = tag;


        new Api().put('/products/' + productID + '/seo', n_form, false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    if (typeof onComplete !== undefined) {
                        onComplete();
                    }
                    toast.success(response.msg);
                } else {
                    toast.error(response.msg);
                }

                setLoading(false);
            }
        })

    };

    return (
        <form onSubmit={handleSubmit} className='animate__animated animate__fadeIn'>
            <Box mt={5}>
                <Box mt={5}>
                    <Paper style={{padding: '25px'}}>
                        <Grid container>
                            <Grid item xs={12}>
                                <TextField
                                    label="اسلاگ"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.slug}
                                    fullWidth
                                    name='slug'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    helperText='بدون فاصله وارد کنید.'
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="متا عنوان"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.meta_title}
                                    fullWidth
                                    name='meta_title'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    helperText='60 تا 255 کاراکتر وارد کنید.'
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="متا توضیحات"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.meta_description}
                                    fullWidth
                                    name='meta_description'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    helperText='60 تا 255 کاراکتر وارد کنید.'
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Box>
                <Box mt={5}>
                    <Paper style={{padding: '25px'}}>
                        <Grid container>
                            <Grid item xs={12} style={{margin: '20px 0'}}>
                                <div style={{margin:"30px 0 10px 0"}}>توضیحات کوتاه</div>
                                {
                                    form.content !== undefined &&
                                    <SunEditor
                                        setOptions={{
                                            height: 200,
                                            buttonList: buttonList.complex
                                        }}
                                        height="100px"
                                        getSunEditorInstance={getSunEditorInstance}
                                        defaultValue={form.short_content}
                                        onChange={(value) => {
                                            let n_form = editorData;
                                            n_form['short_content'] = value;
                                            setEditorData({...n_form});
                                        }}/>
                                }
                            </Grid>
                            <Grid item xs={12} style={{margin: '20px 0'}}>
                                <div style={{margin:"30px 0 10px 0"}}>توضیحات </div>
                                {
                                    form.content !== undefined &&
                                    <SunEditor
                                        setOptions={{
                                            buttonList: buttonList.complex
                                        }}
                                        height="400px"
                                        getSunEditorInstance={getSunEditorInstance}
                                        defaultValue={form.content}
                                        onChange={(value) => {
                                            let n_form = editorData;
                                            n_form['content'] = value;
                                            setEditorData({...n_form});
                                        }}/>
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <TagAutocomplete onChange={(value) => {
                                    let tags = tag;
                                    value.forEach((value) => {
                                        tags.push(value.id);
                                    });
                                    setTag(tags);
                                }}/>
                                {form.tags && form.tags.map((item, index) => {
                                    return (
                                        <Chip
                                            label={item.name}
                                            clickable
                                            color="default"
                                            onDelete={() => {
                                                // remove from form
                                                let tags = form['tags'];
                                                tags.splice(index, 1);
                                                form['tags'] = tags;
                                                // remove from tag
                                                tags = tag;
                                                tags.splice(index, 1);
                                                // init tag in form and tag const
                                                setForm({...form});
                                                setTag(tags);
                                            }}
                                        />
                                    )
                                })}
                            </Grid>
                            <SelectProduct
                                title={"محصولات مرتبط"}
                                type={"product"}
                                state={"related_product"}
                                list={productReducer}
                                formData={form}
                                onchange={(items) => form.related_product = items.related_product}
                            />
                            <SelectProduct
                                title={"مقالات مرتبط"}
                                type={"blog"}
                                state={"related_blogs"}
                                list={contentReducer}
                                formData={form}
                                onchange={(items) => form.related_blogs = items.related_blogs}
                            />
                        </Grid>
                    </Paper>
                </Box>
            </Box>
            <Box mt={2} className='display-flex display-flex-direction-row display-flex-justify-content-flex-end'>
                <Button disabled={loading} variant='contained' color='primary' type="submit">تکمیل اطلاعات</Button>
            </Box>
            {loading && <Loading/>}
        </form>
    );
})


const mapStateToProps = state => ({
    packageTypeReducer: state.packageTypeReducer,
    productReducer: state.productReducer,
    // contentReducer: state.contentReducer,

});

const mapDispatchToProps = (dispatch) => ({
    fetchPackageType: (object) => {
        dispatch(packageTypeAction.fetchPackageType())
    },
    // fetchProducts: (object) => {
    //     dispatch(productAction.fetchProducts(object))
    // },
    // fetchEntities: (object) => {
    //     dispatch(contentAction.contents(object))
    // }
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductEditSeo)

